export default __webpack_public_path__ + "static/AMA20 Finalist Medal_New Brokerage of the Year-4de2c91bf4d5c6c4ecd6f0677093519a.png";